import { FC } from 'react';
import {
  MetaDataAlternateHrefLangList,
  MetaDataCanonical,
  MetaDataDescription,
  MetaDataTitle,
} from '@edikk-edikk/country-frontend';
import { usePageContext } from '#page/hooks';

const MetaData: FC = () => {
  const { page } = usePageContext();

  return (
    <>
      <MetaDataTitle title={page.title} />
      <MetaDataDescription metaDescription={page.metaDescription} />
      <MetaDataCanonical canonical={page.canonical} />
      <MetaDataAlternateHrefLangList alternateHrefLangList={page.alternateHrefLangList} />
    </>
  );
};

export { MetaData };
